import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import BaseItemCollectionView from "./BaseItemCollectionView";
import GameElementSkinFactory from "./GameElementSkinFactory";

export default class BaseBoxView extends AbstractView {

    /**
     * @param {createjs.DisplayObject} target 
     * @param {GameElementSkinFactory} elementFactory 
     */
    constructor(target, elementFactory) {
        super(target);
        this._elementFactory = elementFactory;
        /**@type {BaseItemCollectionView} */
        this._collectionView = null;
        this._enabled = false;
    }

    reset() {
        this._target.removeAllChildren();
        if (this._collectionView) {
            this._collectionView.destroy();
        }
        this._collectionView = null;
    }

    clear() {
        this._collectionView.clear();
    }

    setSize(n) {
        this.reset();
        const boxSkin = this._elementFactory.getBoxForItemCount(n);
        this._target.addChild(boxSkin);
        this._collectionView = new BaseItemCollectionView(boxSkin, this._elementFactory);
        this._collectionView.enabled = this.enabled;
    }

    set enabled(bool) {
        this._enabled = bool;
        if (this._collectionView) {
            this._collectionView.enabled = bool;
        }
    }

    get enabled() {
        return this._enabled;
    }


    fill(itemIds) {
        this._collectionView.fill(itemIds);
    }

}
